import { SharedTable } from '@/modules/shared/components/SharedTable.jsx';

export const Shared = () => {
  return (
    <SharedTable />
  );
};
